import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import "../../../css/certificate.css";
import CloseIcon from "@material-ui/icons/Close";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  TablePagination,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import { toast } from "react-toastify";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import EditIcon from "@material-ui/icons/Edit";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CerificateImage from "../../../images/certificate/badge.png";
import { BsFiletypePdf } from "react-icons/bs";
import { useNotification } from "../../../hooks/useNotification.js";
import { useLocation } from "react-router-dom";
import CustomPdfView from "../../../components/pdfViewer/CustomPdfView.js";
import { IoMdDownload } from "react-icons/io";
import NoDataFound from "../../../components/NoDataFound/index.js";

export default function EmployersCertificate() {
  const classes = useStyles();
  const location_ = useLocation();
  const [currerntPage, setCurrerntPage] = useState();
  const [OpinionData, setOpinionData] = useState();
  const searchParam = new URLSearchParams(location_.search);
  const token = localStorage.getItem("token");
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);

  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [sourceData, setSourceData] = useState([]);
  const [viewResume, setViewResume] = useState({
    isView: false,
    url: "",
  });
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const userId = searchParam.get("userId");
  const userFullName = searchParam.get("fullName");
  const handleNotificationCall = useNotification();
  const handleFeedbackModalOpen = () => {
    setFeedbackModalOpen(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    var data = JSON.stringify({
      page: newPage + 1,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}appreciation/viewMyAppriciations`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setOpinionData(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
  };

  const handleViewResumeClose = () => {
    setViewResume({ isView: false, url: "" });
  };

  const handleViewResumeOpen = (item) => {
    setViewResume({
      isView: true,
      url: item,
    });
  };

  //   const validationSchema = Yup.object().shape({
  //     title: Yup.string().required("Title is required"),
  //     certificate: Yup.mixed()
  //       .required("Certificate is required")
  //       .test(
  //         "fileType",
  //         "Only PDF or Word documents are allowed",
  //         (value) => {
  //           let fileValue = value;
  //           if (value instanceof FileList) {
  //             fileValue = value[0];
  //           }
  //           return fileValue &&
  //             ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(fileValue.type)
  //         }

  //       )
  //       .test(
  //         "fileSize",
  //         "File size should not exceed 2MB",
  //         (value) => {
  //           let fileValue = value;
  //           if (value instanceof FileList) {
  //             fileValue = value[0];
  //           }
  //           return fileValue && fileValue.size <= 2 * 1024 * 1024
  //         }
  //       ),
  //   });

  //   const {
  //     register,
  //     handleSubmit,
  //     reset,
  //     formState: { errors, isSubmitting },
  //   } = useForm({
  //     resolver: yupResolver(validationSchema),
  //   });

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      var data = JSON.stringify({
        page: currerntPage,
      });
      try {
        const viewAlldata = await axios.post(
          `${process.env.REACT_APP_SERVER}appreciation/viewMyAppriciations`,
          {
            data,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          },
        );
        if (viewAlldata.data.status) {
          setLoader(false);
          setCount(viewAlldata.data.count);
          setSourceData(viewAlldata.data.data);
        } else {
          handleNotificationCall("error", viewAlldata.data.message);
        }
      } catch (error) {
        console.log(error);
        handleNotificationCall("error", "Error Happend!");
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, []);

  //   async function handleAdd(values) {
  //     setLoader(true);
  //     try {
  //       const thisFormData = new FormData();
  //       thisFormData.append("title", values.title);
  //       thisFormData.append("file", values.certificate[0]);
  //       thisFormData.append("userId", userId);

  //       const addResponse = await axios.post(`${process.env.REACT_APP_SERVER}appreciation/addAppriciation`, thisFormData, {
  //         headers: {
  //           Authorization: localStorage.getItem("token")
  //         }
  //       });
  //       if (addResponse.data.status) {
  //         reset();
  //         setFeedbackModalOpen(false);
  //         handleNotificationCall("success", addResponse.data.message)
  //       } else {
  //         handleNotificationCall("error", addResponse.data.message);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //       handleNotificationCall("error", "Error Happend!");
  //     } finally {
  //       setLoader(false);
  //     }

  //   }

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="My Appreciations" />
        </Grid>
        {/* <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleFeedbackModalOpen}
        >
          Add Appreciation
        </Button> */}
      </Grid>

{sourceData.length === 0 && <NoDataFound height="80vh" message="No Data Found"/>}

      <Grid container spacing={5}>
        {sourceData.map((item) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={item}>
            <div className="certificate-card">
              <div>
                <h2>CERTIFICATE</h2>
                <h3>{item.title}</h3>
                <div className="certificate-line"></div>
                <div className="certificate-line"></div>
                <div className="sign-line"></div>
              </div>
              <div className="certificate-badge">
                <img src={CerificateImage} alt="certificate-badge" />
              </div>
              <div className="hover-view">
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                  startIcon={<BsFiletypePdf />}
                  onClick={() => {
                    handleViewResumeOpen(item.certificate);
                  }}
                >
                  View
                </Button>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

      {/* <Dialog
        open={feedbackModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={handleFeedbackModalClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(handleAdd)}>
          <h3 style={{ padding: "12px 12px", margin: 0 }}>Feedback</h3>
          <DialogTitle style={{fontSize:"24px"}}>Subscribe</DialogTitle>
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <InputLabel shrink htmlFor="title">
                  Title
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    placeholder="Enter Subject"
                    name="title"
                    {...register("title")}
                    error={errors.title ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.title?.message}
                  </Typography>
                </FormControl>
              </Grid>


              <Grid item xs={12} md={12} lg={12}>
                <InputLabel shrink htmlFor="description">
                  Appreciation File
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    type="file"
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    {...register("certificate")}
                    error={errors.certificate ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.certificate?.message}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleFeedbackModalClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog> */}

      {/* <Dialog
        open={viewResume.isView}
        fullWidth
        maxWidth="xs"
        onClose={handleViewResumeClose}
        aria-labelledby="form-dialog-title"
      >
        <CustomPdfView resumeUrl={viewResume.url} />
      </Dialog> */}

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleViewResumeClose}
        open={viewResume.isView}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogContent>
          <Grid container direction="row" spacing={2}>
            <div
              className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
            >
              <div
                className={classes.inputRoot}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Typography variant="subtitle2">Certificate</Typography>
                <Typography
                  variant="subtitle2"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "15px",
                  }}
                >
                  <>
                    <a
                      style={{ fontSize: "1.3rem", color: "#29b229" }}
                      href={viewResume.url}
                    >
                      <IoMdDownload />
                    </a>
                  </>
                </Typography>
              </div>

              <div className={classes.pdfModalCloseBtn}>
                <CloseIcon
                  className={classes.closeBtn}
                  onClick={handleViewResumeClose}
                />
              </div>
            </div>
            {viewResume.url ? (
              <Grid item xs={12}>
                <CustomPdfView resumeUrl={viewResume.url} />
              </Grid>
            ) : (
              <Grid item xs={12} style={{ marginTop: "40px", padding: "20px" }}>
                <Typography
                  variant="body"
                  style={{ color: "#686D76", textAlign: "center" }}
                  className={classes.flexCenter}
                >
                  No file found here...
                </Typography>
              </Grid>
            )}
            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleViewResumeClose}
              >
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
